import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import useWindowDimensions from '../_common/WindowDimesnions'
import { request } from '../../_network/request'
import { docsURLs } from '../../_network/apiUrls'
import { sortByPriority } from '../subscriptions/_helpers/sort'
import CustomBackdrop from '../_common/CustomBackdrop'
import DocsCatalogItem from './DocsCatalogItem'
import CustomBreadMenu from '../_common/CustomBreadMenu'

const DocsWrapper = () => {
  const theme = useTheme()
  const { width } = useWindowDimensions()
  const location = useLocation()
  const navigate = useNavigate()
  
  const [activeTab, setActiveTab] = useState('config')
  const [isLoading, setIsLoading] = useState(false)
  const [docsCatalog, setDocsCatalog] = useState([])
  const [expandedPanelName, setExpandedPanelName] = useState('')
  const [expandedSubPanelName, setExpandedSubPanelName] = useState('')
  
  const breadMenu = [
    {
      value: 'config',
      label: defaultTexts.openStackConfigurationDocs,
    },
    {
      value: 'billing',
      label: defaultTexts.openStackBillingServiceDocs,
    },
    {
      value: 'backup_automation',
      label: defaultTexts.openStackBackupAutomationDocs,
    },
  ]

  const pageLabelStyle = {
    color: theme.palette.vodka,
    fontSize: '18px',
    fontWeight: '500',
    padding: '0px 0px 20px 20px',
  }

  const wrapperStyle = {
    background: theme.palette.aliceBlue,
    borderRadius: width >= constants.mdBreakpoint ? '0px 20px 20px 20px' : '0px 0px 20px 20px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    padding: '20px',
  }

  const noDocsStyle = {
    fontSize: '24px',
    textAlign: 'center',
    padding: '100px 0px',
  }

  const handleChangeActiveTab = (value) => {
    setActiveTab(value)
  }

  useEffect(() => {
    const fetchDocsCatalogData = async () => {
      setIsLoading(true)

      const url = constants.core_service_domain + '/' + docsURLs.getDocsCatalog + `?section=openstack_${activeTab}_docs`
      
      const request_data = { url, method: 'GET' }
      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setDocsCatalog(sortByPriority(response.data))
      } else {
        setDocsCatalog([])
      }

      setIsLoading(false)
    }

    fetchDocsCatalogData()
  }, [activeTab])

  useEffect(() => {
    const scrollToId = (name) => {
      const element = document.getElementById(`section-${name}`)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }    
    }

    if (docsCatalog.length > 0 && location.hash) {
      const hash_str = location.hash.replace('#', '')
      const hash_splitted = hash_str.split(':')
      
      if (hash_splitted.length > 1) {
        setExpandedPanelName(hash_splitted[0])
        setExpandedSubPanelName(hash_splitted[1])
        scrollToId(hash_splitted[0])
        navigate(location.pathname)
      }
    }
  } ,[docsCatalog, location, navigate])
  
  return (
    <>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <Box sx={{ padding: '40px 20px' }}>

        <Box sx={pageLabelStyle}>{defaultTexts.documentation}</Box>

        <CustomBreadMenu
          breadMenu={breadMenu}
          activeTab={activeTab}
          handleChangeActiveTab={handleChangeActiveTab}
        />

        <Box sx={wrapperStyle}>
          {
            docsCatalog.length > 0 ?
            <>
              {
                docsCatalog.map((item, index) => (
                  <DocsCatalogItem
                    key={index}
                    {...item}
                    expandedPanelName={expandedPanelName}
                    expandedSubPanelName={expandedSubPanelName}
                  />
                ))
              }
            </> :
            <Box sx={noDocsStyle}>{defaultTexts.noDocs}</Box>
          }          
        </Box>

      </Box>
    </>
  )
}

export default DocsWrapper